<template>
    <v-dialog v-model="show" v-if="show" max-width="800px" class="pa-4">
        <div class="popup">
            <v-row style="padding-bottom: 15px;">
                <div v-if="!is_create">
                    <p class="title">{{$t("PopupCreateCompany.edit_company")}}</p>
                </div>
                <div v-else>
                    <p class="title">{{$t("PopupCreateCompany.create_companies")}}</p>
                </div>
            </v-row>
            <SimpleCompanyEditor v-model="companyData" :extra_fields="extra_fields"/>
            <div class="buttons">
            <v-btn @click="cancel()" outlined color="primary" style="margin-right: 20px;">
                        {{$t("PopupCreateCompany.cancel")}}
                    </v-btn>
                    <v-btn @click="save()" color="primary" :loading="loading">
                        <div >{{$t("PopupCreateCompany.save")}}</div>
                    </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import SimpleCompanyEditor from './SimpleCompanyEditor.vue';

export default {
    components: {
        SimpleCompanyEditor,
    },
    props: {
        extra_fields: {
            type: Array,
            default: () => [],
        },
        company :{
            type: Object,
            default: null
        },
        show: {
            type: Boolean,
            required: true,
            default: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            companyData: {},
        };
    },
    methods: {
        cancel() {
            this.$emit('cancel');
        },
        save() {
            this.$emit('save', this.companyData);
        },
    },
    created() {
        console.log('iiii')
        this.companyData = { ...this.company };
        console.log(this.companyData)
    },
    computed: {
        is_create() {
            return this.companyData.id === null;
        },

    }
};
</script>

<style scoped>
.popup {
    background-color: white !important;
    padding: 30px 50px !important;
    border-radius: 8px !important;
    z-index: 9999 !important;
}
.buttons {
  /* Add your styles here */
}
</style>
